import { X } from 'lucide-react'
import { getContrastingTextColor } from '../../../utils/colorUtils'
import { ChipContainer, ChipText, RemoveButton, RemoveButtonVisible } from './styles'

interface LabelChipProps {
  /** Label text to display */
  text: string
  /** Background color of the chip (hex format) */
  color: string
  /** Callback when remove button is clicked */
  onRemove?: () => void
  /** Whether to always show remove button (vs show on hover) */
  alwaysShowRemove?: boolean
  /** Additional class name */
  className?: string
}

/**
 * Reusable label chip component with consistent styling
 * Used for displaying labels across nodes, sidebars, and filters
 */
export function LabelChip({
  text,
  color,
  onRemove,
  alwaysShowRemove = false,
  className,
}: LabelChipProps) {
  const ButtonComponent = alwaysShowRemove ? RemoveButtonVisible : RemoveButton

  return (
    <ChipContainer $color={color} className={className}>
      <ChipText>{text}</ChipText>
      {onRemove && (
        <ButtonComponent
          className="remove-button nodrag"
          $bgColor={color}
          onClick={(e) => {
            e.stopPropagation()
            onRemove()
          }}
          title="Remove label"
        >
          <X size={10} color={getContrastingTextColor(color)} strokeWidth={2.5} />
        </ButtonComponent>
      )}
    </ChipContainer>
  )
}
